


addEventListener('load',function(){document.documentElement.classList.add('motion-ready')});
setTimeout(function(){document.documentElement.classList.add('motion-ready')},600);
// säkerhetsnät: om IO inte kör, visa allt
var reveal = function(){document.querySelectorAll('.rv').forEach(function(e){e.classList.add('in')})};
if('IntersectionObserver' in window){
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})
  },{rootMargin:'0px 0px -8% 0px',threshold:.06});
  document.querySelectorAll('.rv').forEach(function(e){io.observe(e)});
  setTimeout(reveal,2200);
}else{reveal()}
// flikar
document.querySelectorAll('.tab').forEach(function(t){
  t.addEventListener('click',function(){
    var box=t.closest('.tabs');
    box.querySelectorAll('.tab').forEach(function(o){
      o.setAttribute('aria-selected','false');
      document.getElementById(o.getAttribute('aria-controls')).hidden=true;
    });
    t.setAttribute('aria-selected','true');
    document.getElementById(t.getAttribute('aria-controls')).hidden=false;
  });
});
// trappan reser sig
var st=document.getElementById('steps');
if(st){
  if('IntersectionObserver' in window){
    var io2=new IntersectionObserver(function(es){
      es.forEach(function(e){if(e.isIntersecting){st.classList.add('in');io2.disconnect()}})
    },{threshold:.3});
    io2.observe(st);
    setTimeout(function(){st.classList.add('in')},2600);
  }else{st.classList.add('in')}
}
// räknaren
(function(){
  var c=document.getElementById('scenario-copies'),pr=document.getElementById('scenario-price');
  if(!c||!pr) return;
  var eur=function(n){return '\u20ac'+Math.round(n).toLocaleString('en-US')};
  function calc(){
    var n=Math.max(0,parseFloat(c.value)||0), p=Math.max(0,parseFloat(pr.value)||0);
    var net=n*p;
    document.getElementById('scenario-net').textContent=eur(net);
    document.getElementById('creator-share').textContent=eur(net*.7);
    document.getElementById('mdp-share').textContent=eur(net*.3);
    document.getElementById('scenario-count-label').textContent=Math.round(n).toLocaleString('en-US');
  }
  c.addEventListener('input',calc); pr.addEventListener('input',calc); calc();
})();

// navet + den vita sektionen som glider in och växer
// CTA-formuläret
(function(){
  var f=document.getElementById('ctaform'); if(!f) return;
  f.querySelectorAll('.seg').forEach(function(b){
    b.addEventListener('click',function(){
      f.querySelectorAll('.seg').forEach(function(o){o.classList.remove('on');o.setAttribute('aria-checked','false')});
      b.classList.add('on'); b.setAttribute('aria-checked','true');
    });
  });
  var ta=document.getElementById('ask');
  var preset=f.querySelector('.qb:not(.qb-own)');
  var own=null;
  function mark(btn){
    f.querySelectorAll('.qb').forEach(function(o){o.classList.remove('on');o.setAttribute('aria-checked','false')});
    if(btn){btn.classList.add('on'); btn.setAttribute('aria-checked','true');}
  }
  // chippet är ett förslag: klick fyller rutan, klick igen tömmer den
  preset.addEventListener('click',function(){
    if(preset.classList.contains('on')){ ta.value=''; mark(null); }
    else { ta.value=preset.textContent.trim(); mark(preset); }
    ta.focus();
  });
  ta.addEventListener('input',function(){
    mark(ta.value.trim()===preset.textContent.trim() ? preset : null);
  });
  // rutan börjar tom, platshållaren säger vad man kan göra
  ta.value=''; mark(null);
  // Ludvig 2026-10-04: "verkligen fungerar". Användarnamnet krävs, och öppnas ingen mejlapp (Instagrams och TikToks
  // inbyggda webbläsare gör ofta ingenting med mailto) visas meddelandet färdigt att kopiera, med Instagram-DM bredvid.
  var hIn=document.getElementById('handle'), fel=document.getElementById('ctafel'), fall=document.getElementById('ctafall');
  if(hIn) hIn.addEventListener('input',function(){if(hIn.value.trim()){hIn.parentNode.classList.remove('fel');if(fel)fel.hidden=true}});
  f.addEventListener('submit',function(e){
    e.preventDefault();
    var on=f.querySelector('.seg.on'), plat=on?on.dataset.p:'Instagram';
    var h=(hIn.value||'').trim().replace(/^@+/,'').replace(/^https?:\/\/[^\/]+\//,'').replace(/[\/?#].*$/,'');
    if(!h){hIn.parentNode.classList.add('fel'); if(fel) fel.hidden=false; hIn.focus(); return}
    var q=(ta.value||'').trim();
    var sub='Partnership enquiry from @'+h+' on '+plat;
    var body=plat+': @'+h+'\n\n'+(q||'(no question)');
    var gick=false, bort=function(){gick=true};
    window.addEventListener('blur',bort,{once:true}); document.addEventListener('visibilitychange',bort,{once:true});
    location.href='mailto:partnerships@mydigitalproduct.co?subject='+encodeURIComponent(sub)+'&body='+encodeURIComponent(body);
    setTimeout(function(){
      window.removeEventListener('blur',bort); document.removeEventListener('visibilitychange',bort);
      if(gick||!fall) return;
      document.getElementById('ctafall-text').value='To: partnerships@mydigitalproduct.co\n'+sub+'\n\n'+body;
      fall.hidden=false; fall.scrollIntoView({block:'nearest',behavior:'smooth'});
    },1600);
  });
  var kop=document.getElementById('ctafall-kopiera');
  if(kop) kop.addEventListener('click',function(){
    var tx=document.getElementById('ctafall-text'), klar=function(){kop.textContent=f.dataset.kopierat||'Copied'};
    if(navigator.clipboard&&navigator.clipboard.writeText) navigator.clipboard.writeText(tx.value).then(klar,function(){tx.select();document.execCommand('copy');klar()});
    else {tx.select();document.execCommand('copy');klar()}
  });
})();

// stegkorten tänds när man scrollar till dem
(function(){
  var rows=document.querySelectorAll('.steprow'); if(!rows.length) return;
  var light=function(){rows.forEach(function(r){r.classList.add('lit')})};
  if('IntersectionObserver' in window){
    var io3=new IntersectionObserver(function(es){
      es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('lit');io3.unobserve(e.target)}})
    },{rootMargin:'0px 0px -18% 0px',threshold:.25});
    rows.forEach(function(r){io3.observe(r)});
    setTimeout(light,3000);
  } else light();
})();

// "Try it" kör appens egen huvudknapp
document.querySelectorAll('.trythis').forEach(function(b){
  b.addEventListener('click',function(){
    var side=b.closest('.phone-side'); if(!side) return;
    var app=side.querySelector('.app-frame'); if(!app) return;
    app.scrollIntoView({block:'center',behavior:'smooth'});
    var primary=app.querySelector('[data-action]:not([disabled])')||app.querySelector('.app-tabs button:not([aria-current="true"])');
    if(primary) setTimeout(function(){primary.click()},420);
  });
});

var nav=document.querySelector('.site-header');
var hero=document.querySelector('.hero');
if(!nav||!hero){nav=null}
var ov=document.querySelector('.overlap');
var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
function onScroll(){
  if(!hero) return;
  var y=scrollY, hh=hero.offsetHeight;
  if(nav){nav.classList.toggle('dark-lock', y>8 && y<hh-90);
  nav.classList.toggle('stuck', y>=hh-90);}
  if(ov && !reduce){
    // 0 -> 1 medan heron rullar förbi
    var t=Math.min(1,Math.max(0,(y-(hh*.25))/(hh*.65)));
    var e=t*t*(3-2*t);
    ov.style.setProperty('--ov-y',(72-72*e).toFixed(1)+'px');
  }
}
var _t=false;
function onScrollRaf(){ if(_t) return; _t=true; requestAnimationFrame(function(){ _t=false; onScroll(); }); }
addEventListener('scroll',onScrollRaf,{passive:true});
addEventListener('resize',onScrollRaf,{passive:true});
onScroll();

